import Svg from "@/components/Svg";

const CLIP_ID = "clip0_invite_patient_icon";

export default function InvitePatientIcon({ size = 20, color = "#1A1A1A" }) {
  const height = (size * 19) / 20;

  return (
    <Svg
      as="svg"
      width={size}
      height={height}
      minWidth={size}
      minHeight={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${CLIP_ID})`}>
        <path
          d="M10.4901 1.38503C12.1439 1.38503 13.4879 2.72652 13.4879 4.37471C13.4879 6.02289 12.1419 7.36439 10.4901 7.36439C8.83833 7.36439 7.4903 6.02289 7.4903 4.37471C7.4903 2.72652 8.83634 1.38503 10.4901 1.38503ZM10.4901 0C8.06604 0 6.10059 1.95882 6.10059 4.37471C6.10059 6.79059 8.06604 8.74941 10.4901 8.74941C12.9142 8.74941 14.8776 6.79059 14.8776 4.37471C14.8776 1.95882 12.9142 0 10.4901 0Z"
          fill={color}
        />
        <path
          d="M17.7606 18.5002H0.00794123L0.00198531 17.8137C0.00198531 17.7899 0 17.7682 0 17.7464C0 13.1343 4.74092 9.38281 10.5698 9.38281C10.9529 9.38281 11.2646 9.69345 11.2646 10.0753C11.2646 10.4572 10.9529 10.7678 10.5698 10.7678C5.78718 10.7678 1.84832 13.5616 1.42744 17.1152H17.7606C18.1437 17.1152 18.4554 17.4259 18.4554 17.8077C18.4554 18.1896 18.1437 18.5002 17.7606 18.5002Z"
          fill={color}
        />
        <path
          d="M16.256 8.59766C14.1873 8.59766 12.5117 10.2676 12.5117 12.3293C12.5117 14.391 14.1873 16.061 16.256 16.061C18.3247 16.061 20.0003 14.391 20.0003 12.3293C20.0003 10.2676 18.3247 8.59766 16.256 8.59766ZM16.256 15.0776C14.7353 15.0776 13.4984 13.8449 13.4984 12.3293C13.4984 10.8137 14.7353 9.58102 16.256 9.58102C17.7768 9.58102 19.0136 10.8137 19.0136 12.3293C19.0136 13.8449 17.7768 15.0776 16.256 15.0776Z"
          fill={color}
        />
        <path
          d="M17.8935 11.8265H16.6964V10.7027C16.6964 10.4692 16.5078 10.2812 16.2735 10.2812C16.0392 10.2812 15.8506 10.4692 15.8506 10.7027V11.8265H14.6535C14.3815 11.8265 14.1611 12.0462 14.1611 12.3172C14.1611 12.5883 14.3815 12.8079 14.6535 12.8079H15.8506V13.9318C15.8506 14.1653 16.0392 14.3532 16.2735 14.3532C16.5078 14.3532 16.6964 14.1653 16.6964 13.9318V12.8079H17.8935C18.1655 12.8079 18.3859 12.5883 18.3859 12.3172C18.3859 12.0462 18.1655 11.8265 17.8935 11.8265Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id={CLIP_ID}>
          <rect width="20" height="18.5" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
}
